module.exports = __webpack_public_path__ + "static/insert_category_legend_1-65fc3c28c5a024ba7fa44b3e448f3cf5.png";